import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { APSMaster, WebSwoDeliveryRequest, WebCompany, WebCustomer, ContactWeb } from "src/app/models";
import { ApsService, UtilityService, CompanyService, CustomerService, ContactService } from "src/app/services";
import { Subscription } from "rxjs";
import { EditBankDialogService } from "../../aps/edit-bank-dialog/edit-bank-dialog.service";
import { ConfirmDialogService, ConfirmDialogOptions } from "src/app/shared";
import { SharedService } from "src/app/services";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { EditCardDialogService } from "../../aps/edit-card-dialog/edit-card-dialog.service";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-bank-item",
  templateUrl: "./bank-item.component.html",
  styleUrls: ["./bank-item.component.scss"]
})
export class BankItemComponent implements OnInit, OnDestroy
{

  @Input() bank: APSMaster;
  dialogRef: any; // some changes made to help w/ the unit test file.
  private availableCardsSubscription: Subscription;
  public availableCards: APSMaster[];
  private availableBanksSubscription: Subscription;
  public availableBanks: APSMaster[];
  companySubscription: Subscription;
  company: WebCompany;

  customerSubscription: Subscription;
  customer: WebCustomer;

  contactList: ContactWeb[];
  contactSubscription: Subscription;
  defaultEmail: string = ""
  requestData: WebSwoDeliveryRequest = {};

  constructor(
    private apsService: ApsService,
    public dialog: MatDialog,
    private editBankDialogService: EditBankDialogService,
    private confirmDialogService: ConfirmDialogService,
    public sharedService: SharedService,
    private utilityService: UtilityService,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private contactService: ContactService,
  ) { }
  ngOnInit(): void
  {
    this.availableBanksSubscription = this.apsService.availableBanks.subscribe((banks) => 
    {
      this.availableBanks = banks;
    }
    );
    this.availableCardsSubscription = this.apsService.availableCards.subscribe((cards) => 
    {
      this.availableCards = cards;
    }
    );
    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });

    this.companySubscription = this.companyService.company.subscribe((company) => 
    {
      this.company = company;
    });
    this.contactSubscription = this.contactService.contacts.subscribe((contacts) => 
    {
      this.contactList = contacts;
      this.defaultEmail = this.setDefaultEmail();
    })
  }

  public handleEditClick(): void
  {
    this.editBankDialogService.openDialog(this.bank)

  }

  public handleDeleteClick(): void
  {
    this.requestData.ContactEmail = this.defaultEmail;
    this.requestData.CustId = this.customer.CustId;
    this.requestData.Contact = this.customer.Name;
    this.requestData.Company = this.company;
    this.requestData.Customer = this.customer;

    if (
      this.apsService.isAutoPayOn &&
      (this.availableBanks.length === 1 && this.availableCards.length === 0)
    )
    {
      const dialogData = new ConfirmDialogOptions(
        "Delete Bank Account?",
        "To remain enrolled in Autopay, you must have a payment account on file. If you wish to remain on Autopay, select No, add a new form of payment, and then delete this bank account. Deleting this bank account will terminate your enrollment in Autopay. Continue?"
      );

      this.confirmDialogService
        .openDialog(dialogData)
        .afterClosed()
        .subscribe((result) =>
        {
          if (result)
          {
            this.apsService.deletePaymentMethod(this.bank).subscribe({
              next: () =>
              {
                this.utilityService.sendAutopayCancellationEmails(this.requestData).subscribe({
                  next: (r) =>
                  {
                    if (r)
                    {
                      this.dialog.open(AlertDialogComponent, {
                        id: "auto-pay-cancellation-alert",
                        panelClass: "form-field-less-than-180",
                        width: "500px",
                        height: "200px",
                        data: {
                          title: "Autopay Cancellation",
                          message: "Your account will be removed from Autopay.",
                          buttonText: "Close"
                        }
                      });

                      this.dialogRef.close();
                    }
                    else
                    {
                      this.errorDialog("The bank account was deleted, but autopay cancellation email failed.");
                    }
                  },
                  error: (error) =>
                  {
                    this.errorDialog("The bank account was deleted, but there was a problem sending the autopay cancellation email. " + error);
                  }
                });
              },
              error: (error) =>
              {
                this.errorDialog("There was a problem deleting your bank account. " + error);
              }
            });
          }
        });
    }
    else
    {
      const dialogData = new ConfirmDialogOptions(
        "Delete Bank",
        `Delete ${ this.bank.BankTypeString } ${ this.bank.MaskedBankAcct }?`
      );

      this.dialogRef = this.confirmDialogService.openDialog(dialogData);

      this.dialogRef.afterClosed().subscribe(result =>
      {
        if (result)
        {
          this.apsService.deletePaymentMethod(this.bank).subscribe({
            next: () =>
            {
            },
            error: (error) =>
            {
              this.errorDialog("There was a problem deleting your bank account. " + error);
            }
          });
        }
      });
    }
  }
  errorDialog(error): void
  {
    this.dialog.open(ErrorDialogComponent, {
      minWidth: "360px",
      data: error,
    });
  }
  
  public setDefaultEmail(): string
  {
    if (this.contactList.length > 0)
    {
      if (this.contactList[0] !== null || this.contactList[0].Email !== "")
      {
        this.defaultEmail = this.contactList[0].Email;
      }
    }
    return this.defaultEmail;
  }
  ngOnDestroy(): void
  {
    this.availableBanksSubscription.unsubscribe();
    this.availableCardsSubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
    this.companySubscription.unsubscribe();
    this.contactSubscription.unsubscribe();
  }
}
